import { render, staticRenderFns } from "./VATBreakdown.vue?vue&type=template&id=b5b81e4a&scoped=true"
import script from "./VATBreakdown.vue?vue&type=script&lang=ts"
export * from "./VATBreakdown.vue?vue&type=script&lang=ts"
import style0 from "./VATBreakdown.vue?vue&type=style&index=0&id=b5b81e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b81e4a",
  null
  
)

export default component.exports